import { State } from "@/types/State"

export const DEFAULT_ABBREVIATED_STATE_VALUE = "NC"

const abbreviatedStatesList: State[] = [
  { text: "AL", value: "AL" },
  { text: "AK", value: "AK" },
  { text: "AS", value: "AS" },
  { text: "AZ", value: "AZ" },
  { text: "AR", value: "AR" },
  { text: "CA", value: "CA" },
  { text: "CO", value: "CO" },
  { text: "CT", value: "CT" },
  { text: "DE", value: "DE" },
  { text: "DC", value: "DC" },
  { text: "FM", value: "FM" },
  { text: "FL", value: "FL" },
  { text: "GA", value: "GA" },
  { text: "GU", value: "GU" },
  { text: "HI", value: "HI" },
  { text: "ID", value: "ID" },
  { text: "IL", value: "IL" },
  { text: "IN", value: "IN" },
  { text: "IA", value: "IA" },
  { text: "KS", value: "KS" },
  { text: "KY", value: "KY" },
  { text: "LA", value: "LA" },
  { text: "ME", value: "ME" },
  { text: "MH", value: "MH" },
  { text: "MD", value: "MD" },
  { text: "MA", value: "MA" },
  { text: "MI", value: "MI" },
  { text: "MN", value: "MN" },
  { text: "MS", value: "MS" },
  { text: "MO", value: "MO" },
  { text: "MT", value: "MT" },
  { text: "NE", value: "NE" },
  { text: "NV", value: "NV" },
  { text: "NH", value: "NH" },
  { text: "NJ", value: "NJ" },
  { text: "NM", value: "NM" },
  { text: "NY", value: "NY" },
  { text: "NC", value: "NC" },
  { text: "ND", value: "ND" },
  { text: "MP", value: "MP" },
  { text: "OH", value: "OH" },
  { text: "OK", value: "OK" },
  { text: "OR", value: "OR" },
  { text: "PW", value: "PW" },
  { text: "PA", value: "PA" },
  { text: "PR", value: "PR" },
  { text: "RI", value: "RI" },
  { text: "SC", value: "SC" },
  { text: "SD", value: "SD" },
  { text: "TN", value: "TN" },
  { text: "TX", value: "TX" },
  { text: "UT", value: "UT" },
  { text: "VT", value: "VT" },
  { text: "VI", value: "VI" },
  { text: "VA", value: "VA" },
  { text: "WA", value: "WA" },
  { text: "WV", value: "WV" },
  { text: "WI", value: "WI" },
  { text: "WY", value: "WY" },
]

export default abbreviatedStatesList
